export default __webpack_public_path__ + "static/media/photo--sm--misc-10.c035c365.jpg";